import { Conversation, MetaConversation } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { TimelineConversationType } from 'components/conversation/components/timelineComponent/timelineComponent';

export const conversation = {
  from: {
    timelineItem(item: TimelineConversationType): Conversation {
      return {
        message_delivery_status: null,
        initial_channel: item.channel,
        direction: item.direction,
        is_abandoned: null,
        is_callback_consumed: false,
        is_closed: item.is_closed,
        last_message_created_at: null,
        queued_at: null,
        status: item.status,
        id: item.id,
      };
    },
  },
};

export const metaConversation = {
  from: {
    conversation(
      conversation: Conversation,
      requester?: User,
    ): MetaConversation {
      return {
        conversation,
        requester,
        callersOnHold: [],
        extraParties: {},
        integrations: [],
        isAssignedToMe: false,
        linkedConversations: [],
        messages: [],
        unread: 0,
      };
    },

    timelineItem(
      item: TimelineConversationType,
      requester?: User,
    ): MetaConversation {
      return {
        conversation: conversation.from.timelineItem(item),
        requester,
        callersOnHold: [],
        extraParties: {},
        integrations: [],
        isAssignedToMe: false,
        linkedConversations: [],
        messages: [],
        unread: 0,
      };
    },
  },
};
